import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_TOTAL_DEMANDS } from '../config/settings/environment'

/**
 * Get total demands of the given buyer.
 */
export const getTotalDemands = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_TOTAL_DEMANDS}/v1/compradores/demandas/total/${dni}`)
})

/**
 * Get list of demands.
 */
export const getListOfDemands = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_TOTAL_DEMANDS}/v1/compradores/demandas/${dni}`)
})
